import React, { useRef, useState, useMemo } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import MenuCarouselFixed from './MenuCarouselFixed';
import './Menu.css';
import './MenuCarouselFixed.css';

// 🖼️ Imports images par section (1 sous-dossier par carte du menu)
import smoothies1 from '../assets/smoothies/smoothies-1.jpg';
import smoothies2 from '../assets/smoothies/smoothies-2.jpg';
import smoothies3 from '../assets/smoothies/smoothies-3.jpg';
import smoothies4 from '../assets/smoothies/smoothies-4.jpg';
import smoothies5 from '../assets/smoothies/smoothies-5.jpg';

import sundaeMilkshake1 from '../assets/sundae-milkshakes/sundae-milkshakes-1.jpg';
import sundaeMilkshake2 from '../assets/sundae-milkshakes/sundae-milkshakes-2.jpg';
import sundaeMilkshake3 from '../assets/sundae-milkshakes/sundae-milkshakes-3.jpg';
import sundaeMilkshake4 from '../assets/sundae-milkshakes/sundae-milkshakes-4.jpg';

import bubbleTea1 from '../assets/bubble-tea-granita/bubble-tea-granita-1.jpg';
import bubbleTea2 from '../assets/bubble-tea-granita/bubble-tea-granita-2.jpg';
import bubbleTea3 from '../assets/bubble-tea-granita/bubble-tea-granita-3.jpg';
import bubbleTea4 from '../assets/bubble-tea-granita/bubble-tea-granita-4.jpg';
import bubbleTea5 from '../assets/bubble-tea-granita/bubble-tea-granita-5.jpg';
import bubbleTea6 from '../assets/bubble-tea-granita/bubble-tea-granita-6.jpg';
import bubbleTea7 from '../assets/bubble-tea-granita/bubble-tea-granita-7.jpg';

import burger1 from '../assets/burger-hotdog-pancakes/burger-hotdog-pancakes-1.jpg';
import burger2 from '../assets/burger-hotdog-pancakes/burger-hotdog-pancakes-2.jpg';
import burger3 from '../assets/burger-hotdog-pancakes/burger-hotdog-pancakes-3.jpg';
import burger4 from '../assets/burger-hotdog-pancakes/burger-hotdog-pancakes-4.jpg';

gsap.registerPlugin(ScrollTrigger);

const Menu = () => {
  const menuRef = useRef(null);
  const [smoothiesImageIndex, setSmoothiesImageIndex] = useState(0);
  const [milkshakeImageIndex, setMilkshakeImageIndex] = useState(0);
  const [bubbleTeaImageIndex, setBubbleTeaImageIndex] = useState(0);
  const [hotDogImageIndex, setHotDogImageIndex] = useState(0);
  const [activeSection] = useState('tout-frais');
  const [isUserInteracting, setIsUserInteracting] = useState(false);
  const [showAllToppings, setShowAllToppings] = useState(false);

  // Toppings avec logique d'affichage
  const allToppings = "Spéculoos, peanut butter, Smarties, cacahuète, cookies, KitKat, Bueno, Bueno White, Country, Oreo, Daim, caramel beurre salé, Schokobon, Nutella, pécan";
  const shortToppings = "Spéculoos, peanut butter, Smarties, cacahuète, cookies, KitKat";
  
  // 🖼️ Images pour chaque section (carrousel : src uniquement)
  const smoothiesImages = useMemo(() => [
    { src: smoothies1 },
    { src: smoothies2 },
    { src: smoothies3 },
    { src: smoothies4 },
    { src: smoothies5 }
  ], []);

  const milkshakesImages = useMemo(() => [
    { src: sundaeMilkshake1 },
    { src: sundaeMilkshake2 },
    { src: sundaeMilkshake3 },
    { src: sundaeMilkshake4 }
  ], []);

  const bubbleTeaImages = useMemo(() => [
    { src: bubbleTea1 },
    { src: bubbleTea2 },
    { src: bubbleTea3 },
    { src: bubbleTea4 },
    { src: bubbleTea5 },
    { src: bubbleTea6 },
    { src: bubbleTea7 }
  ], []);

  const hotDogsPancakesImages = useMemo(() => [
    { src: burger1 },
    { src: burger2 },
    { src: burger3 },
    { src: burger4 }
  ], []);

  return (
    <section className="menu-fixed" ref={menuRef} id="menu">
      
      {/* Titre principal du menu */}
      <div className="menu-header">
        <h1 className="menu-main-title">Menu Pinky</h1>
      </div>
      
      {/* Section 1: Smoothies & Bubble Tea - Carte à gauche + Carrousel à droite */}
      <div className="menu-section-fixed">
        <div className="menu-content-container-fixed">
          <div className="menu-content-fixed">
            
            {/* Carte menu rose */}
            <div className="menu-card">
              <h2 className="menu-section-title-fixed">Smoothies</h2>
              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">PINKY</div>
                  <div className="menu-item-desc-fixed">Framboise, coco</div>
                </div>
              </div>
              
              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">CLOUD</div>
                  <div className="menu-item-desc-fixed">Orange, banane, fraise</div>
                </div>
              </div>
              
              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">EXOTIQUE</div>
                  <div className="menu-item-desc-fixed">Mangue, passion, coco</div>
                </div>
              </div>
              
              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">PIÑA COLADA</div>
                  <div className="menu-item-desc-fixed">Ananas, coco</div>
                </div>
              </div>
              
              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">FRUITS ROUGES</div>
                  <div className="menu-item-desc-fixed">Fraise, framboise, cerise, cassis</div>
                </div>
              </div>

              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">SUNRISE</div>
                  <div className="menu-item-desc-fixed">Fraise, kiwi, mangue</div>
                </div>
              </div>
              
              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">BANANA-NUT</div>
                  <div className="menu-item-desc-fixed">Banane, peanut butter, miel, lait</div>
                </div>
              </div>
              
              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">KARAYA</div>
                  <div className="menu-item-desc-fixed">Litchi, ananas, passion</div>
                </div>
              </div>
              
              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">DOLCE</div>
                  <div className="menu-item-desc-fixed">Avocat, datte, miel, lait</div>
                </div>
              </div>

              <h3 className="menu-category-title-fixed">Supplément</h3>
              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">SUPPLÉMENT TOPPING</div>
                  <div className="menu-item-desc-fixed">Ajout de topping sur smoothie</div>
                </div>
              </div>
            </div>

            {/* Carrousel d'images */}
            <MenuCarouselFixed 
              images={smoothiesImages}
              activeSection={activeSection}
              isActive={true}
              currentImageIndex={smoothiesImageIndex}
              setCurrentImageIndex={setSmoothiesImageIndex}
              isUserInteracting={isUserInteracting}
              setIsUserInteracting={setIsUserInteracting}
            />
            
          </div>
        </div>
      </div>

      {/* Section 2: Milkshakes & Desserts - Carte à gauche + Carrousel à droite */}
      <div className="menu-section-fixed">
        <div className="menu-content-container-fixed">
          <div className="menu-content-fixed">
            
            {/* Carte menu rose */}
            <div className="menu-card">
              <h2 className="menu-section-title-fixed">Sundae<br/>& Milkshake</h2>
              

              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">SUNDAE</div>
                  <div className="menu-item-desc-fixed">Base glace vanille + coulis</div>
                </div>
              </div>
              
              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">MILKSHAKE</div>
                  <div className="menu-item-desc-fixed">Base glace vanille + coulis + chantilly</div>
                </div>
              </div>


              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">COULIS</div>
                  <div className="menu-item-desc-fixed">Spéculoos, caramel beurre salé, confiture de fraise, Nutella, chocolat blanc</div>
                </div>
              </div>


              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">TOPPINGS</div>
                  <div className="menu-item-desc-fixed">
                    {showAllToppings ? allToppings : shortToppings}
                    {!showAllToppings && (
                      <button 
                        onClick={() => setShowAllToppings(true)}
                        style={{
                          color: 'rgba(255, 255, 255, 0.8)',
                          background: 'none',
                          border: 'none',
                          textDecoration: 'underline',
                          cursor: 'pointer',
                          marginLeft: '5px',
                          fontSize: 'inherit',
                          fontFamily: 'inherit'
                        }}
                      >
                        ...voir plus
                      </button>
                    )}
                    {showAllToppings && (
                      <button 
                        onClick={() => setShowAllToppings(false)}
                        style={{
                          color: 'rgba(255, 255, 255, 0.8)',
                          background: 'none',
                          border: 'none',
                          textDecoration: 'underline',
                          cursor: 'pointer',
                          marginLeft: '5px',
                          fontSize: 'inherit',
                          fontFamily: 'inherit'
                        }}
                      >
                        voir moins
                      </button>
                    )}
                  </div>
                </div>
              </div>
              

              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">FRUITS FRAIS</div>
                  <div className="menu-item-desc-fixed">Banane, fraise, mangue, coco, ananas, passion, avocat, framboise</div>
                </div>
              </div>
            </div>

            {/* Carrousel d'images */}
            <MenuCarouselFixed 
              images={milkshakesImages}
              activeSection={activeSection}
              isActive={true}
              currentImageIndex={milkshakeImageIndex}
              setCurrentImageIndex={setMilkshakeImageIndex}
              isUserInteracting={isUserInteracting}
              setIsUserInteracting={setIsUserInteracting}
            />
            
          </div>
        </div>
      </div>

      {/* Section 3: Bubble Tea & Granita - Carte à gauche + Carrousel à droite */}
      <div className="menu-section-fixed">
        <div className="menu-content-container-fixed">
          <div className="menu-content-fixed">
            
            {/* Carte menu rose */}
            <div className="menu-card">
              <h2 className="menu-section-title-fixed">Bubble Tea<br/>& Granita</h2>
              

              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">BASE THÉ</div>
                  <div className="menu-item-desc-fixed">Thé noir ou thé jasmin + sirops + popping</div>
                </div>
              </div>
              
              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">THÉ AU LAIT ARÔMÉ</div>
                  <div className="menu-item-desc-fixed">Thé + lait + arômes (vanille, coco, matcha, taro)</div>
                </div>
              </div>


              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">GRANITÉA</div>
                  <div className="menu-item-desc-fixed">Granita à base de thé</div>
                </div>
              </div>

              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">BUBBLE TEA FRUITÉ</div>
                  <div className="menu-item-desc-fixed">Thé + sirops fruités + popping</div>
                </div>
              </div>
            </div>

            {/* Carrousel d'images */}
            <MenuCarouselFixed 
              images={bubbleTeaImages}
              activeSection={activeSection}
              isActive={true}
              currentImageIndex={bubbleTeaImageIndex}
              setCurrentImageIndex={setBubbleTeaImageIndex}
              isUserInteracting={isUserInteracting}
              setIsUserInteracting={setIsUserInteracting}
            />
            
          </div>
        </div>
      </div>

      {/* Section 4: Hot Dogs & Pancakes - Carte à gauche + Carrousel à droite */}
      <div className="menu-section-fixed">
        <div className="menu-content-container-fixed">
          <div className="menu-content-fixed">
            
            {/* Carte menu rose */}
            <div className="menu-card">
              <h2 className="menu-section-title-fixed">BURGER<br/>& Hot Dog<br/>Mini Pancakes</h2>
              

              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">HOT DOG</div>
                  <div className="menu-item-desc-fixed">Pain brioché avec une base, un topping et un coulis</div>
                </div>
              </div>
              
              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">BURGER</div>
                  <div className="menu-item-desc-fixed">Pain brioché avec une base, un topping et un coulis</div>
                </div>
              </div>

              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">MINI PANCAKES</div>
                  <div className="menu-item-desc-fixed">12 mini pancakes avec une base, un topping et un coulis</div>
                </div>
              </div>

              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">BASE</div>
                  <div className="menu-item-desc-fixed">Glace vanille</div>
                </div>
              </div>

              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">CHANTILLY</div>
                  <div className="menu-item-desc-fixed">Glace vanille</div>
                </div>
              </div>

              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">TOPPING</div>
                  <div className="menu-item-desc-fixed">Spéculoos, cacahuète, smarties, pécan, cookies, KitKat, Bueno, Bueno White, Country, Oreo, Daim</div>
                </div>
              </div>

              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">COULIS</div>
                  <div className="menu-item-desc-fixed">Spéculoos, caramel beurre salé, confiture de fraise, Nutella, chocolat blanc</div>
                </div>
              </div>

              <div className="menu-item-fixed">
                <div className="menu-item-content">
                  <div className="menu-item-name-fixed">FRUIT</div>
                  <div className="menu-item-desc-fixed">Banane, fraise</div>
                </div>
              </div>
            </div>

            {/* Carrousel d'images */}
            <MenuCarouselFixed 
              images={hotDogsPancakesImages}
              activeSection={activeSection}
              isActive={true}
              currentImageIndex={hotDogImageIndex}
              setCurrentImageIndex={setHotDogImageIndex}
              isUserInteracting={isUserInteracting}
              setIsUserInteracting={setIsUserInteracting}
            />
            
          </div>
        </div>
      </div>

    </section>
  );
};

export default Menu;